export default {
  PDF: 0,
  Excel: 1,
  Word: 2,
  XML: 3,
  DVC: 4
};
